var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exportarDocumento("E")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Excel")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exportarDocumento("P")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-pdf-o" }),
                _c("span", [_vm._v("PDF")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-8" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "H" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "H")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "A" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "P" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "P")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaDesde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaDesde", $$v)
                            },
                            expression: "form.fechaDesde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Desde:")])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaHasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaHasta", $$v)
                            },
                            expression: "form.fechaHasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Hasta:")])
                      ],
                      1
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2 select2-field--stretch",
                  class: { "select2--disabled": !_vm.administraTodasBodegas }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.optionsBodegas,
                          id: "bodegas"
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal:")
                      ])
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.registros.length > 0
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.nombreBodega != null && _vm.nombreBodega != "",
                          expression:
                            "nombreBodega != null && nombreBodega != ''"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c("h6", [
                        _vm._v(_vm._s("SUCURSAL: " + _vm.nombreBodega))
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", { staticClass: "table--bordered" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#F3F2F2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Producto\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.diasSemana, function(diaSemana, index) {
                              return _c(
                                "th",
                                {
                                  key:
                                    index.toString() +
                                    _vm
                                      .moment(new Date())
                                      .format("YYYYMMDDHHmmss") +
                                    "dia",
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#F3F2F2"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(diaSemana.nombre_dia))
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#F3F2F2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Ventas\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#F3F2F2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Precio\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#F3F2F2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    Monto\n                  "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.registros, function(registro, index2) {
                            return _c(
                              "tr",
                              {
                                key:
                                  index2.toString() +
                                  _vm
                                    .moment(new Date())
                                    .format("YYYYMMDDHHmmss") +
                                  "reg"
                              },
                              [
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [_vm._v(_vm._s(registro.item_descripcion))]
                                ),
                                _vm._v(" "),
                                _vm._l(registro.detalles, function(
                                  detalle,
                                  index3
                                ) {
                                  return _c(
                                    "td",
                                    {
                                      key:
                                        index3.toString() +
                                        _vm
                                          .moment(new Date())
                                          .format("YYYYMMDDHHmmss") +
                                        "detalle",
                                      staticStyle: { "font-size": "10px" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(detalle.cantidad))
                                      ])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [_vm._v(_vm._s(registro.total_cantidad))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.moneyFormat(
                                            parseFloat(registro.total_valor) /
                                              parseFloat(
                                                registro.total_cantidad
                                              )
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.moneyFormat(registro.total_valor)
                                      )
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _vm._l(_vm.diasSemana, function(
                                diaSemana,
                                index4
                              ) {
                                return _c(
                                  "td",
                                  {
                                    key:
                                      index4.toString() +
                                      _vm
                                        .moment(new Date())
                                        .format("YYYYMMDDHHmmss") +
                                      "dia_total",
                                    staticStyle: {
                                      "font-size": "10px",
                                      "background-color": "#F3F2F2"
                                    }
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(_vm._s(diaSemana.cantidad))
                                    ])
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#F3F2F2"
                                  }
                                },
                                [_c("b", [_vm._v(_vm._s(_vm.totalCantidad))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#F3F2F2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.moneyFormat(_vm.totalPrecio))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#F3F2F2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.moneyFormat(_vm.totalValor))
                                    )
                                  ])
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [_c("reportes-historicos-excel", { attrs: { tipoReporte: "vp" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de ventas por productos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticStyle: { "font-size": "10px", "background-color": "#F3F2F2" } },
      [_c("b", [_vm._v("TOTAL VENTAS:")])]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37605741", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37605741","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteVentasProductos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-37605741","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteVentasProductos.vue
// module chunks = 0